'use strict';

class SimpleDemandDisplay {
  constructor() {
    'ngInject';

    this.restrict = 'E';
    this.scope = {
      timeStr: '=',
      maxPower: '=',
      predictedDemand: '=',
      currentPower: '=',
      powerDiff: '=',
      deviceError: '=',
      remainingDiff: '=',
      targetPower: '=',
      limitPower: '=',
      contractPower: '=',
      toggle: '&'
    };
    this.template = require('./simple-demand-display.html');
  }

  link(scope) {
    scope.blackMode = true;

    scope.getColorClass = () => {
      if (!scope.deviceError.has_error) { return 'simple-demand-color-normal'; }
      if(this.isError(scope.deviceError)) { return 'simple-demand-color-contract'; }

      switch (scope.deviceError.demand_level) {
        case 0:
          return 'simple-demand-color-normal';
        case 1:
          return 'simple-demand-color-target';
        case 2:
          return 'simple-demand-color-limit';
        case 3:
          return 'simple-demand-color-contract';
      }
    };

    scope.isNotifyTime = () => {
      if (scope.remainingDiff < 300) { return 'simple-demand-time-flash'; }
    };

    scope.toggleMode = () => {
      scope.blackMode = !scope.blackMode;
    };

    scope.thresholdTitle = () => {
      if (scope.predictedDemand <= scope.targetPower) {
        return '目標電力';
      } else if (scope.predictedDemand <= scope.limitPower) {
        return '限界電力';
      } else {
        return '契約電力';
      }
    };

    scope.thresholdValue = () => {
      if (scope.predictedDemand <= scope.targetPower) {
        return scope.targetPower;
      } else if (scope.predictedDemand <= scope.limitPower) {
        return scope.limitPower;
      } else {
        return scope.contractPower;
      }
    };
  }

  isError(deviceError) {
    return deviceError.cloud_disconnected ||
      deviceError.meter_off ||
      deviceError.meter_fault ||
      deviceError.meter_not_found ||
      deviceError.demand_fault;
  }
}

export default angular.module('leptonApp.simpleDemandDisplay', [])
  .directive('simpleDemandDisplay', [() => new SimpleDemandDisplay()])
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/demand/detail/simple-demand-display/simple-demand-display.directive.js